import { TYPECONTENT } from '../constants/TrackingConstants';

export default class ContentParams {
  constructor(data) {
    this.con_id = data?.con_id;
    this.rq_tp = TYPECONTENT.CONTENT;
    this.pro_tp = data?.pro_tp;
    this.pl_lo_id = data?.pl_lo_id;
    this.con_vi_id = data?.con_vi_id;
    this.con_src = data?.con_src;
    this.con_cost = data?.con_cost;
    this.pl_lo_sz = data?.pl_lo_sz;
    this.pl_lo_ts = data?.pl_lo_ts;
    this.con_vi_ts = data?.con_vi_ts;
    this.con_pos = data?.con_pos || -1;
  }

  setDeliveryVideoDuration(duration) {
    this.dl_vid_dur = duration && !Number.isNaN(duration) ? duration : 0;
    return this;
  }

  setIdContent(contentId) {
    this.con_id = contentId;
    return this;
  }

  setProductType(productType) {
    // let playerType = videoController.modelVideoData.isVideoProducer()
    //   ? 1
    //   : videoController.config.playerType;
    // const result = TpxPlayerTypes.find((item) => item.id === playerType);
    // this.pro_tp = result ? result.name : 'no-def';
    this.pro_tp = productType;
    return this;
  }

  setPlayerLoadId(playerLoadId) {
    this.pl_lo_id = playerLoadId;
    return this;
  }

  setPlayerLoadSize(playerLoadSize) {
    this.pl_lo_sz = playerLoadSize;
    return this;
  }

  setContentViewId(contentViewId) {
    this.con_vi_id = contentViewId;
    return this;
  }

  setContentSource(contentSource) {
    this.con_src = contentSource;
    return this;
  }

  setContentCost(contentCost) {
    this.con_cost = contentCost;
    return this;
  }

  setPlayerLoadTimeStamp(playerloadTs) {
    this.pl_lo_ts = playerloadTs;
    return this;
  }

  setPlayerContentViewTimeStamp(ContentViewTs) {
    this.con_vi_ts = ContentViewTs;
    return this;
  }

  setContentPosition(contentPosition) {
    this.con_pos = contentPosition;
    return this;
  }

  build() {
    return {
      con_id: this.con_id,
      rq_tp: TYPECONTENT.CONTENT,
      pro_tp: this.pro_tp,
      pl_lo_id: this.pl_lo_id,
      con_vi_id: this.con_vi_id,
      con_src: this.con_src,
      con_cost: this.con_cost,
      pl_lo_sz: this.pl_lo_sz,
      pl_lo_ts: this.pl_lo_ts,
      con_vi_ts: this.con_vi_ts,
      con_pos: this.con_pos,
    };
  }
}
